import React, { useEffect } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Form, FormGroup, Label } from 'reactstrap';
import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { societyValidationSchema } from './utils/validations';

const CompanyPositionsFormModal = ({ isOpen, toggle, onSubmit, initialData }) => {
  const {
    handleSubmit,
    control,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(societyValidationSchema),
    defaultValues: {
      name: '',
    },
  });

  // Cargar datos iniciales para edición
  useEffect(() => {
    if (initialData) {
      reset(initialData);
    } else {
      reset({
        name: '',
      });
    }
  }, [initialData, reset]);

  const onSubmitForm = (data) => {
    console.log("Data: ", data) 
    onSubmit(data);
    toggle(); // Cerrar modal después de enviar
    reset(); // Limpiar formulario
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader toggle={toggle}>
        {initialData ? 'Editar Posición' : 'Crear Nueva Posición'}
      </ModalHeader>
      <Form onSubmit={handleSubmit(onSubmitForm)}>
        <ModalBody>
          <FormGroup>
            <Label for="name">Nombre</Label>
            <Controller
              name="name"
              control={control}
              render={({ field }) => (
                <input
                  {...field}
                  id="name"
                  className={`form-control ${errors.name ? 'is-invalid' : ''}`}
                  placeholder="Ingrese el nombre de la posición"
                />
              )}
            />
            {errors.name && <div className="invalid-feedback">{errors.name.message}</div>}
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggle}>
            Cancelar
          </Button>
          <Button color="primary" type="submit">
            {initialData ? 'Guardar Cambios' : 'Crear'}
          </Button>
        </ModalFooter>
      </Form>
    </Modal>
  );
};

export default CompanyPositionsFormModal;
